import { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
import * as S from "./styled";
//Components
import ActionButton from "../../../../Button/ActionButton";
import Delete from "../../../../Delete";
import LayoutWithList from "../../../../LayoutModal/WithList";
import Loading from "../../../../Loading";
import Toast from "../../../../Toast";
import Update from "../Update";
//hooks
import apiRequest from "../../../../../hooks/apiRequest";
import useLoading from "../../../../../hooks/useLoading";
import { useMultipleModal } from "../../../../../hooks/useMultipleModal";
//Icons
import { PencilSimple, Trash } from "@phosphor-icons/react";
//Interfaces
import { ICategory, Inputs } from "Interfaces/ICategory";
import { ICreate } from "Interfaces/ICreate";

export default function CreateCategory({
  isOpenModal,
  setModalClose,
  refreshFrames,
  setToastData,
  setToastOpen
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    reset,
    formState: { errors },
  } = useForm<Inputs>();

  const { isOpenModal: isOpenModalVisible, toggleModalVisibility } = useMultipleModal();
  const { isLoading, startLoading, stopLoading } = useLoading();
  const tableHead = ["#", "Nome", "Ações"];
  const [category, setCategory] = useState<ICategory[]>([]);
  const [openModalOptId, setOpenModalOptId] = useState<number | null>(null);
  const [hasNewData, setHasNewData] = useState(false);
  const [toastDataUpdate, setToastDataUpdate] = useState({
    status: 200,
    message: "",
  });

  const clickPopTable = (id: number, acao: string) => {
    setOpenModalOptId(id);
    toggleModalVisibility(acao);
  };

  const fetchData = async () => {
    startLoading();
    try {
      const response = await axiosInstance.get(`category-expense`);
      setCategory(response.data);
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (isOpenModal && category.length === 0) {
      fetchData();
    }
  }, [isOpenModal]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    try {

      const formattedData = {
        category_expense: data.category_expense.toUpperCase(),
      };

      const response = await apiRequest("category-expense", "POST", formattedData);
      const status = response.status;
      if (status === 201) {
        setToastData({
          status: status,
          message: 'Cadastrado com sucesso!',
        });

        setHasNewData(true);
        setToastOpen(true);
        fetchData();
      }
    } catch (error: any) {
      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    }
  };

  const onClose = () => {
    setModalClose();
    reset();

    if (hasNewData) {
      refreshFrames();
      setHasNewData(false);
      toggleModalVisibility('open-toast');
    }
  }

  const handleRefreshFrames = () => {
    fetchData();
    setHasNewData(true);
  };

  if (isOpenModal) {
    return (
      <LayoutWithList
        title="Registrar Categoria"
        subTitle="Cadastre uma nova categoria em sua base de dados."
        setModalClose={onClose}
      >
        <S.Container>
          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>
                Nome da categoria
                <span>*</span>
              </S.Label>
              <S.Input
                placeholder="Informe o nome da categoria"
                type="text"
                {...register("category_expense", { required: true })}
              />
              {errors.category_expense && <S.InforErro>Campo Obrigatório</S.InforErro>}
            </S.FormInput>

            <S.ContentButton>
              <ActionButton
                name="Salvar"
                onClick={handleFormSubmit(onSubmit)}
              />
            </S.ContentButton>
          </S.SeparateDiv>
        </S.Container>

        <S.Footer>
          <S.TitleList>Tipo de Categoria Cadastradas</S.TitleList>
          {isLoading ? (
            <Loading />
          ) : (
            <S.Table>
              <thead>
                <tr>
                  {tableHead.map((val) => {
                    return <th>{val}</th>;
                  })}
                </tr>
              </thead>
              <tbody>
                {category.map((val, index) => {
                  return (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{val.category_expense}</td>
                      <td>
                        <S.ContentButton>
                          <S.ButtonIconTable
                            onClick={() => clickPopTable(val.id, "update")}
                          >
                            <PencilSimple size={20} />
                          </S.ButtonIconTable>

                          <S.ButtonIconTable
                            onClick={() => clickPopTable(val.id, "delete")}
                          >
                            <Trash size={20} color="red" />
                          </S.ButtonIconTable>
                        </S.ContentButton>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </S.Table>
          )}
        </S.Footer>

        <Update
          isOpenModal={isOpenModalVisible('update')}
          setModalClose={() => toggleModalVisibility("update")}
          selectedUrlId={openModalOptId}
          refreshFrames={handleRefreshFrames}
          setToastOpen={() => toggleModalVisibility('open-toast')}
          setToastData={setToastDataUpdate}
        />
        <Toast
          openToast={isOpenModalVisible('open-toast')}
          closeToast={() => toggleModalVisibility('open-toast')}
          message={toastDataUpdate.message}
          status={toastDataUpdate.status}
        />
        <Delete
          updateList={fetchData}
          endpoint="category-expense"
          selectedProductId={openModalOptId}
          isOpenModal={isOpenModalVisible("delete")}
          setModalClose={() => toggleModalVisibility("delete")}
        />
      </LayoutWithList>
    );
  }
  return null;
}
